// src/components/PieChart.js
import { useRef } from "react";
import { Chart as Chartjs, registerables } from 'chart.js';
import { Line, Chart } from "react-chartjs-2";
import { getRelativePosition } from 'chart.js/helpers';
import PropTypes from "prop-types";
import moment from "moment";
import 'chartjs-adapter-moment';
import zoomPlugin from "chartjs-plugin-zoom";
import data from "nextus/Maps/HeatMap/data";

import { draw, generate } from 'patternomaly';

Chartjs.register(...registerables);
Chartjs.register(zoomPlugin); // REGISTER PLUGIN

var timeout, current_chart;
var scroll_event_happening = false;

function GradientReader(height, pixel) {

  const canvas = document.createElement('canvas');         // create canvas element
  const ctx = canvas.getContext('2d');                     // get context
  var gradientBg = ctx.createLinearGradient(0, 0, 0, height);    // create a gradient

  canvas.width = 1;                                        // 101 pixels incl.
  canvas.height = height;                                  // as the gradient

  gradientBg.addColorStop(0.85, "rgba(38, 124, 204, 0.85)"); //0.2
  gradientBg.addColorStop(0.70, "rgba(131, 180, 226, 0.85)"); //0.7
  gradientBg.addColorStop(0.4, "rgba(239,128,98,0.85)"); //1
  gradientBg.addColorStop(0.1, "rgba(255, 24, 24, 0.85)"); //1

  ctx.fillStyle = gradientBg;                                     // set as fill style
  ctx.fillRect(0, 0, canvas.width, canvas.height);        // draw a single line

  // method to get color of gradient at % position [0, 100]
  //console.log(pixel)
  return ctx.getImageData(0, pixel, 1, 1).data;
}

var shown_epoch_local;

function GradientMinMaxLineChart({ chartData = [], event_data = [], startLimit = 0, endLimit = 0, min = 0, min_value, max = null, max_value, startTime, endTime, groupSize, setStartTime, setEndTime, setCurrentTime, setUseLiveData, shownEpoch }) {

  const chartRef = useRef(null);

  shown_epoch_local = shownEpoch

  // console.log("re render")
  // console.log(scroll_event_happening);
  // debugger;

  const scrollEvent = (chart) => {
    // console.log(timeout);
    current_chart = chart;
    if (typeof timeout != 'undefined') {
      clearTimeout(timeout);
      timeout = undefined;
      // console.log('timeout cleared')
    }

    timeout = setTimeout(() => {
      // console.log('running scroll event - timeout expired')
      // console.log(scroll_event_happening);

      runWheelScrollEvent(current_chart);

      clearTimeout(timeout)
      timeout = undefined;
      scroll_event_happening = false;
    }, 400);
  }

  const runWheelScrollEvent = ({ chart }) => {
    var start_time, end_time, group_size;
    let min_limit = moment(0)
    let max_limit = moment();
    // console.log(chart.scales.x.min)
    let min_moment = moment(chart.scales.x.min);
    let max_moment = moment(chart.scales.x.max);

    if (min_moment.isBefore(min_limit)) {
      start_time = min_limit;
    }
    else {
      start_time = min_moment;
    }

    if (max_moment.isAfter(max_limit)) {
      end_time = max_limit;
    }
    else {
      end_time = max_moment;
    }
    setTimeout(function () {
      // console.log("set start time")
      setStartTime(start_time.unix());
      setEndTime(end_time.unix());
    })


  };

  const verticalHoverLine = {
    id: 'verticalHoverLine',
    defaults: {
      width: 2,
      color: '#FF4949',
      dash: [3, 3],
    },
    afterInit: (chart, args, opts) => {
      chart.verticalHoverLine = {
        x: 0,
        y: 0,
      }
    },
    afterEvent: (chart, args) => {
      const { inChartArea } = args;
      const { type, x, y } = args.event;
      // console.log(args)

      chart.verticalHoverLine = { x, y, draw: inChartArea, runEvent: !args.replay }
      chart.draw();
    },
    afterDatasetsDraw: (chart, args, opts) => {
      // console.log(args);
      const { ctx, chartArea: { top, bottom, left, right }, canvas } = chart;
      if (typeof chart.verticalHoverLine == 'undefined' && !shown_epoch_local) return;
      const { x, y, draw } = chart.verticalHoverLine;
      ctx.save();

      if (x >= left && x <= right && y <= bottom && y >= top) {
        var dataX = chart.scales.x.getValueForPixel(x);
        // console.log(scroll_event_happening)
        if (!scroll_event_happening && chart.verticalHoverLine.runEvent && typeof timeout == 'undefined') {
          // console.log('set time')
          // console.log("setting time")
          setCurrentTime(moment(dataX));
        }


        ctx.beginPath();
        ctx.lineWidth = opts.width;
        ctx.strokeStyle = opts.color;
        ctx.moveTo(x, bottom);
        ctx.lineTo(x, top);
        ctx.stroke();

        ctx.restore();
      }
      else {
        // debugger;
        // console.log(shown_epoch_local)
        if (shown_epoch_local) {
          var dataX = chart.scales.x.getPixelForValue(shown_epoch_local * 1000);
          ctx.beginPath();
          ctx.lineWidth = opts.width;
          ctx.strokeStyle = opts.color;
          ctx.moveTo(dataX, bottom);
          ctx.lineTo(dataX, top);
          ctx.stroke();

          ctx.restore();
        }
      }
    }
  };

  var event_list = [];

  const activeEventRanges = {
    id: 'activeEventRanges',
    beforeDraw(chart, args, pluginOptions) {
      const { ctx, chartArea: { top, bottom, left, right, width, height }, canvas } = chart;
      // ctx.fillRect(left, top, width, height);
      ctx.save();
      // ctx.fillStyle = '#FFFBD0';
      ctx.fillStyle = draw('diagonal-right-left', 'rgb(255, 243, 132)', 'rgb(255, 255, 255)', 25);

      for (var event of event_data) {
        var startX = chart.scales.x.getPixelForValue(moment(event.start_time).unix() * 1000);
        var endX = chart.scales.x.getPixelForValue(moment(event.end_time).unix() * 1000);

        if (startX >= left && endX <= right) {
          ctx.fillRect(startX, top, endX - startX, height);
        }
      }
    }
  }

  // console.log(endTime - startTime)

  // debugger;

  const options = {
    layout: {
      padding: 8
    },
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 0
    },
    // interaction: {
    //   mode: 'index',
    //   intersect: false
    // },
    plugins: {
      verticalHoverLine: {
        color: 'black'
      },
      zoom: {
        zoom: {
          mode: 'x',
          drag: {
            enabled: false,
          },
          wheel: {
            enabled: true,
          },
          pinch: {
            enabled: false,
          },
          speed: 0.5, sensitivity: 0.5,
          onZoomComplete: function (chart) {
            // console.log("on zoom complete");
            // console.log(scroll_event_happening);
            scrollEvent(chart)
          },
          onZoom: function () {
            // console.log("on zoom")
            // console.log(scroll_event_happening)
            scroll_event_happening = true;
          }
        },
        limits: {
          x: {
            min: startLimit * 1000,
            max: endLimit * 1000,
            minRange: 1000,
          }
        },
        title: {
          display: false,
          text: ""
        },
        tooltip: {
          enabled: true,
        }
      },
      legend: {
        display: false
      }
    },
    elements: {
      point: {
        radius: 4,
        hoverRadius: 5
      }
    },
    scales: {
      x: {
        type: 'time',
        min: startTime,
        max: endTime,
        ticks: {
          maxRotation: 0, // Prevents rotation
          minRotation: 0  // Ensures no rotation is forced
        }
      },
      y: {
        min: min,
        max: max,
        suggestedMin: min,
        suggestedMax: max,
        ticks: {
          stepSize: 1
        }
      }
    }
  };

  if ((endTime - startTime) / 1000 < 86400) {
    options.scales.x1 = {
      type: 'time',
      min: startTime,
      max: endTime,
      border: {
        display: false
      },
      grid: {
        display: false
      },
      time: {
        unit: 'day',
        displayFormats: {
          day: 'ddd DD/MM'
        }
      },
      ticks: {
        // stepSize: 10,
        autoSkip: false,
        maxRotation: 0
      }
    }
  }

  var chart = (
    <Line
      ref={chartRef}
      data={chartData}
      options={options}
      plugins={[verticalHoverLine, activeEventRanges]}
    />
  )


  // Chartjs.register();

  return chart;
};

// Typechecking props for the GradientMinMaxLineChart
GradientMinMaxLineChart.propTypes = {
  chartData: PropTypes.object,
  event_data: PropTypes.array,
  min: PropTypes.number,
  min_value: PropTypes.number,
  max: PropTypes.number,
  max_value: PropTypes.number,
  field: PropTypes.object,
  startTime: PropTypes.instanceOf(moment()),
  setStartTime: PropTypes.func,
  endTime: PropTypes.instanceOf(moment()),
  setEndTime: PropTypes.func,
  groupSize: PropTypes.number,
  setCurrentTime: PropTypes.func,
  setUseLiveData: PropTypes.func,
  startLimit: PropTypes.number,
  endLimit: PropTypes.number
};


export default GradientMinMaxLineChart;